import { createFileRoute, redirect } from "@tanstack/react-router";
import { AdminDashboard } from "../../components/admin/admin-dashboard";
import { AppHeader } from "../../components/app-header";
import { meQuery } from "../../lib/queries";

/** Operator-only dashboard. Non-admins are bounced home; the API is gated too. */
export const Route = createFileRoute("/_authed/admin")({
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(meQuery).catch(() => null);
    if (!me?.isAdmin) throw redirect({ to: "/", search: {} });
  },
  component: AdminPage,
});

function AdminPage() {
  return (
    <div className="min-h-dvh bg-background">
      <AppHeader />
      <main id="main" className="mx-auto max-w-[1200px] px-4 pt-8 pb-16 sm:px-6">
        <h1 className="text-2xl font-semibold">Operator dashboard</h1>
        <p className="mt-1 mb-6 text-sm text-muted-foreground">Everything running on Carno — cost, revenue and margin, per app and overall.</p>
        <AdminDashboard />
      </main>
    </div>
  );
}
